var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EventEmitter, OnInit } from '@angular/core';
import { PhoneNumbersService } from './phone-numbers.service';
import { MsisdnService } from '../../shared/msisdn/msisdn.service';
import { MatDialog } from '@angular/material';
import { FormBuilder } from '@angular/forms';
import { map } from 'rxjs/operators';
import { Ng1IpInfoService } from '../../shared/ng1/ng1-ip-info.service';
import { NotificationService } from '../../shared/notification.service';
import { ConfirmDialogComponent } from '../../shared/dialog/confirm-dialog/confirm-dialog.component';
import { Router } from '@angular/router';
var PhoneNumbersComponent = /** @class */ (function () {
    function PhoneNumbersComponent(phoneNumbersService, dialog, fb, msisdnService, router, ng1IpInfoService, notify) {
        this.phoneNumbersService = phoneNumbersService;
        this.dialog = dialog;
        this.fb = fb;
        this.msisdnService = msisdnService;
        this.router = router;
        this.ng1IpInfoService = ng1IpInfoService;
        this.notify = notify;
        this.changePhoneNumberList = new EventEmitter();
    }
    PhoneNumbersComponent.prototype.ngOnInit = function () {
        this.prepareMsisdnsList();
        this.checkMainPhoneNumbers();
        this.addForm = this.createAddForm();
    };
    PhoneNumbersComponent.prototype.onChangePhoneNumbers = function (selectValue) {
        var _this = this;
        this.dialog
            .open(ConfirmDialogComponent, {
            data: {
                title: selectValue
                    ? 'PHONE_NUMBERS.HIDE_MODAL.HIDE_PHONE_NUMBER_HEADER'
                    : 'PHONE_NUMBERS.HIDE_MODAL.SHOW_PHONE_NUMBER_HEADER',
                body: selectValue
                    ? 'PHONE_NUMBERS.HIDE_MODAL.HIDE_PHONE_NUMBER_BODY'
                    : 'PHONE_NUMBERS.HIDE_MODAL.SHOW_PHONE_NUMBER_BODY'
            }
        })
            .afterClosed()
            .subscribe(function (confirm) {
            if (confirm) {
                _this.numbers.restricted = selectValue;
                _this.phoneNumbersService.save(_this.campaignId, _this.numbers).subscribe(function () {
                    _this.refreshNumbers();
                });
            }
            else {
                _this.numbers.restricted = !selectValue;
            }
        });
    };
    PhoneNumbersComponent.prototype.prepareMsisdnsList = function () {
        var _this = this;
        this.msisdns = this.msisdnService
            .msisdns()
            .pipe(map(function (msisdns) {
            return msisdns.filter(function (msisdn) { return !_this.numbers.campaignsMsisdns.find(function (campaignsMsisdn) { return campaignsMsisdn.id === msisdn.id; }); });
        }));
    };
    PhoneNumbersComponent.prototype.refreshNumbers = function () {
        var _this = this;
        this.msisdnService.projectNumbers(this.campaignId).subscribe(function (numbers) {
            _this.numbers = numbers;
            _this.checkMainPhoneNumbers();
            _this.prepareMsisdnsList();
            _this.changePhoneNumberList.next(numbers);
        });
    };
    PhoneNumbersComponent.prototype.onSelectPhoneNumber = function (select) {
        var _this = this;
        if (!select.value) {
            return;
        }
        this.phoneNumbersService.addPhoneNumber(this.campaignId, select.value.id).subscribe(function () {
            _this.notify.open('PHONE_NUMBERS.MESSAGES.ADD');
            _this.addForm.get('msisdnId').setValue(null);
            _this.refreshNumbers();
        });
    };
    PhoneNumbersComponent.prototype.checkMainPhoneNumbers = function () {
        var _this = this;
        this.numbers.campaignsMsisdns = this.numbers.campaignsMsisdns.map(function (number) {
            return __assign({}, number, { mainPhoneNumber: _this.numbers.mainCallerId.id === number.id, mainEeaPhoneNumber: _this.numbers.eeaCallerId.id === number.id });
        });
    };
    PhoneNumbersComponent.prototype.onSetMainPhoneNumber = function (number) {
        var _this = this;
        this.numbers.mainCallerId = number;
        this.phoneNumbersService.save(this.campaignId, this.numbers).subscribe(function () {
            _this.notify.open('PHONE_NUMBERS.MESSAGES.CHANGE_MAIN', {
                number: number.msisdn ? number.msisdn : number.label
            });
            _this.refreshNumbers();
        });
    };
    PhoneNumbersComponent.prototype.onSetMainEeaPhoneNumber = function (number) {
        var _this = this;
        this.numbers.eeaCallerId = number;
        this.phoneNumbersService.save(this.campaignId, this.numbers).subscribe(function () {
            _this.notify.open('PHONE_NUMBERS.MESSAGES.CHANGE_EEA', {
                number: number.msisdn ? number.msisdn : number.label
            });
            _this.refreshNumbers();
        });
    };
    PhoneNumbersComponent.prototype.onRemovePhoneNumber = function (number) {
        var _this = this;
        this.dialog
            .open(ConfirmDialogComponent, {
            data: {
                title: 'PHONE_NUMBERS.MODAL.HEADER',
                body: 'PHONE_NUMBERS.MODAL.BODY'
            }
        })
            .afterClosed()
            .subscribe(function (confirm) {
            if (confirm) {
                _this.phoneNumbersService.removePhoneNumber(_this.campaignId, number).subscribe(function () {
                    _this.refreshNumbers();
                }, function (error) {
                    if (error.error instanceof Array) {
                        _this.notify.open(error.error[0], {}, _this.notify.getDefaultCloseAction());
                    }
                });
            }
        });
    };
    PhoneNumbersComponent.prototype.createAddForm = function () {
        return this.fb.group({
            msisdnId: null
        });
    };
    PhoneNumbersComponent.prototype.gotoNewNumber = function () {
        var code = this.ng1IpInfoService.getCountry();
        this.router.navigate(['get-new-number', 'pricing', code]);
    };
    return PhoneNumbersComponent;
}());
export { PhoneNumbersComponent };
